import {
  Duration,
  format,
  formatDuration,
  formatISO,
  Interval,
  intervalToDuration,
  minutesToMilliseconds,
} from "date-fns";

export {
  addDays,
  addMinutes,
  subMinutes,
  startOfDay,
  startOfToday,
  formatISO,
  parseISO,
  minutesToMilliseconds,
  isPast,
  isBefore,
  isAfter,
} from "date-fns";

type DateLike = string | Date | number;

export const DATE_FORMAT_US = "MM/dd/yyyy";
export const DATE_FORMAT_EU = "dd/MM/yyyy";
export const TIME_FORMAT = "HH:mm:ss";
export const DATETIME_FORMAT = `${DATE_FORMAT_US} ${TIME_FORMAT}`;

const formatDistanceLocale = { xDays: "{{count}}d", xHours: "{{count}}h", xMinutes: "{{count}}m" };
const shortEnLocale = {
  formatDistance: (token: string, count: number) => formatDistanceLocale[token].replace("{{count}}", count),
};

const asDate = (date: DateLike) => new Date(date);

export const formatDate = (value?: DateLike, formatStr = DATE_FORMAT_US) =>
  value ? format(asDate(value), formatStr) : "";

export const formatISODate = (value?: DateLike) => formatISO(asDate(value), { representation: "date" });

export const formatDateTime = (value?: DateLike, formatStr = DATETIME_FORMAT) =>
  value ? format(asDate(value), formatStr) : "";

export const formatDayOfWeek = (value?: DateLike) => (value ? format(asDate(value), "EEEE") : "");

const minutesToDuration = (minutes: number): Duration => {
  const interval: Interval = {
    start: 0,
    end: minutesToMilliseconds(minutes),
  };
  return intervalToDuration(interval);
};

export const formatMinutesAsDuration = (minutes = 0, abbreviated = false): string => {
  const duration = minutesToDuration(minutes);

  const formatOptions = {
    zero: false,
    locale: abbreviated ? shortEnLocale : undefined,
  };
  return formatDuration(duration, formatOptions);
};
